import {Component, HostListener, OnInit} from '@angular/core';
import { DeviceCategory } from '../../model/device-category';
import { BasicFilters } from '../../model/filters/basic-filters';
import { SortOrder } from '../../model/sort-order';
import { DeviceCategoriesService } from '../../services/device-categories.service';
import { TenantsService } from '../../services/tenants.service';
import { TranslocoService } from '@ngneat/transloco';
import { CommonMessagesService } from '../../services/common-messages.service';
import { AuthGuard } from '../../common/auth-guard.service';
import { Tenant } from '../../model/tenant';
import {FiltersService} from "../../services/filters.service";

@Component({
  selector: 'app-device-categories',
  templateUrl: './device-categories.component.html',
  styleUrls: ['./device-categories.component.scss']
})
export class DeviceCategoriesComponent implements OnInit {

  public categories: DeviceCategory[];
  public totalCategories: number;
  public loadingCategories: boolean;
  public tenants: Tenant[];

  public rows = 10;
  public first = 0;
  public selected = [];

  public filtersVisible: boolean;
  public currentFilters: BasicFilters;
  public displayFailedDeleteList: boolean;
  public failedDeleteList: any[];
  public filtersFilled: boolean;

  constructor(private deviceCategoriesService: DeviceCategoriesService,
              private tenantsService: TenantsService,
              private i18n: TranslocoService,
              public authGuardService: AuthGuard,
              private commonMessagesService: CommonMessagesService,
              private filtersService: FiltersService<BasicFilters>) {
    this.currentFilters = new BasicFilters();
  }

  ngOnInit(): void {
    if (this.filtersService.getCurrentFilters(this.constructor.name) !== undefined) {
      this.filtersFilled = true;
    }
    this.categories = new Array(this.rows);
    if (this.authGuardService.superAdminRequired()) {
      this.tenantsService.getTenants().subscribe(response => {
        this.tenants = response.tenants
          .sort((a, b) => a.name > b.name ? 1 : -1);
        Object.assign(this.currentFilters, this.filtersService.getCurrentFilters(this.constructor.name));
      });
    } else {
      Object.assign(this.currentFilters, this.filtersService.getCurrentFilters(this.constructor.name));
    }
  }

  private loadCategories(offset: number, limit: number): void {
    this.loadingCategories = true;
    this.categories = new Array(this.rows);
    this.deviceCategoriesService.getDeviceCategories(offset, limit, this.filtersService.getCurrentFilters(this.constructor.name) === undefined ? this.currentFilters: this.filtersService.getCurrentFilters(this.constructor.name))
      .subscribe(response => {
        this.categories = response.deviceCategories;
        this.totalCategories = response.totalElements;
        this.loadingCategories = false;
      });
  }

  onPageChange(event): void {
    this.currentFilters.sortField = event.sortField;
    this.currentFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
    this.loadCategories(event.first / event.rows, event.rows);
  }

  resetFilters(): void {
    this.currentFilters = new BasicFilters();
    this.currentFilters.sortField = 'name';
    this.currentFilters.sortOrder = SortOrder.ASCENDING;
    this.filtersFilled = false;
    this.filtersService.setCurrentFilters(undefined, this.constructor.name);
    this.applyFilters(true);
  }

  applyFilters(reset?: boolean): void {
    this.first = 0;
    if (reset !== true){
      this.filtersService.setCurrentFilters(this.currentFilters, this.constructor.name);
      this.filtersFilled = true;
    }
    this.loadCategories(this.first / this.rows, this.rows);
  }

  confirmAndDelete(category: DeviceCategory): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => {
      this.deleteCategory(category.tenant.uuid, category.name);
    });
  }

  deleteCategory(tenantUuid: string, name: string): void {
    this.tenantsService.deleteTenantDeviceCategory(tenantUuid, name).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadCategories(this.first / this.rows, this.rows);
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status);
    });
  }

  confirmAndDeleteSelected(): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => this.deleteSelected(), true);
  }

  deleteSelected(): void {
    if (this.selected.length === 0) { return; }
    const identifiers = this.selected.map(item => ({tenantUuid: item.tenant.uuid, name: item.name}));

    this.deviceCategoriesService.deleteDeviceCategories(identifiers).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadCategories(this.first / this.rows, this.rows);
    }, error => {
      this.failedDeleteList = error.error.categoriesBeingUsed;
      this.displayFailedDeleteList = true;
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status, true);
    });
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {
    if (event.key === 'f') {
      this.filtersVisible = true;
    }
    if (event.key === 'Escape') {
      this.filtersVisible = false;
    }
  }

}
